import hsv from './hsv';
import color_grouper from './color_grouper'


export let coordinates = Object.assign({}, hsv, color_grouper.filters);
export let setBase = color_grouper.setBase;
